import {
  PlatformGameSession,
  createPlatformAdapter,
  isHostedGamePlatform,
  resolveGamePlatform,
  type PlatformRuntimeHooks,
} from '@brick-rogue/platform-adapters';

export const GAME_PLATFORM = resolveGamePlatform(import.meta.env.MODE);
export const IS_HOSTED_GAME_PLATFORM = isHostedGamePlatform(GAME_PLATFORM);

let activeRuntimeHooks: PlatformRuntimeHooks | null = null;
let audioMuted = false;
let suspended = false;

const runtimeBridge: PlatformRuntimeHooks = {
  setAudioMuted: (muted) => {
    audioMuted = muted;
    activeRuntimeHooks?.setAudioMuted(muted);
  },
  setSuspended: (nextSuspended) => {
    suspended = nextSuspended;
    activeRuntimeHooks?.setSuspended(nextSuspended);
  },
};

export const GAME_PLATFORM_SESSION = new PlatformGameSession(
  createPlatformAdapter(GAME_PLATFORM),
  runtimeBridge,
);

export function initializeGamePlatform(): Promise<void> {
  return GAME_PLATFORM_SESSION.initialize();
}

export async function finishGamePlatformLoading(): Promise<void> {
  await initializeGamePlatform();
  GAME_PLATFORM_SESSION.loadingFinished();
}

export function bindGamePlatformRuntimeHooks(runtimeHooks: PlatformRuntimeHooks): () => void {
  activeRuntimeHooks = runtimeHooks;
  runtimeHooks.setAudioMuted(audioMuted);
  runtimeHooks.setSuspended(suspended);
  return () => {
    if (activeRuntimeHooks === runtimeHooks) {
      activeRuntimeHooks = null;
    }
  };
}
